'use es6';

export const SUPPORTED_SALES_ENGAGEMENT_TYPES = ['CALL', 'MEETING', 'TASK', 'EMAIL', 'NOTE', 'CONVERSATION_SESSION'];